import styled from 'styled-components';

export const ProductImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 0 5px rgba(0,0,0,0.1);
`;

export const ProductImg = styled.img`
  width: 100%;
  height: auto;
  max-height: 200px;
  object-fit: cover;
`;

export const ProductImgEnlarged = styled.img`
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: cover;
`;

export const ImageCaption = styled.div`
  margin-top: 8px;
  font-size: 0.9rem;
  color: #333;
`;

export const ImageActions = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 10px;
`;

export const DeleteButton = styled.button`
  min-width: 165px;
  width: auto;
  height: 50px;
  letter-spacing: 0.5px;
  line-height: 50px;
  margin: 10px;
  padding: 0 35px 0 35px;
  font-size: 15px;
  background-color: red;
  color: white;
  text-transform: uppercase;
  font-family: 'Open Sans Condensed';
  font-weight: bolder;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: white;
    color: black;
    border: 1px solid black;
  }
`;

export const PrimaryTag = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
  background-color: gold;
  color: black;
  padding: 2px 6px;
  font-size: 0.75rem;
  border-radius: 4px;
  font-weight: bold;
`;